import { Integration, IntegrationPost } from "../../types"
import { normalizeUrl } from "../../common/utils"
import { REGEX_HEX_COLOR } from "../../common/constants"

const isValidHexColor = (color?: string) =>
  !!color && REGEX_HEX_COLOR.test(color)

export const buildIntegrationPayload = (values: Integration) => {
  const {
    id,
    owner,
    url,
    title,
    type,
    accent_color,
    secondary_accent_color,
    app_settings
  } = values

  const {
    mort_calc = 0,
    afford_calc = 0,
    lead_workflow,
    pricing_set_id,
    settings,
    rate_table_config
  } = app_settings ?? {}

  const pricing: 1 | 0 = app_settings?.pricing === 1 ? 1 : 0
  const { rateCardsConfigId } = settings ?? {}

  const normalizedAccentColor = accent_color || settings?.accent_color || ""
  const normalizedSecondaryColor =
    secondary_accent_color || settings?.secondary_accent_color || ""

  const postValues: Omit<
    IntegrationPost,
    "accent_color" | "secondary_accent_color"
  > &
    Partial<Pick<IntegrationPost, "accent_color" | "secondary_accent_color">> =
    {
      id,
      url: normalizeUrl(url),
      owner,
      title,
      type,
      mort_calc,
      afford_calc,
      lead_workflow,
      pricing,
      pricing_set_id,
      aboutBoxes: settings?.aboutBoxes ?? false,
      expose_api: settings?.expose_api ?? true,
      disableCalcCards: settings?.disableCalcCards ?? false,
      postUrl: settings?.postUrl ?? "",
      loReviews: settings?.loReviews ?? false,
      brandReviews: settings?.brandReviews ?? false,
      rateTable: settings?.rateTable ?? false,
      rateCards: settings?.rateCards ?? false,
      customParams: settings?.customParams,
      ga_tag: settings?.ga_tag ?? "",
      ga_mode: settings?.ga_mode ?? "",
      contactForm: settings?.contactForm ?? 0,
      rate_table_config: rate_table_config ?? "",
      rateCardsConfigId: rateCardsConfigId ?? "",
      billing_exempt: settings?.billing_exempt ?? false,
      globalExitPopUpEnable: settings?.globalExitPopUpEnable ?? false
    }

  if (isValidHexColor(normalizedAccentColor)) {
    postValues.accent_color = normalizedAccentColor
  }
  if (isValidHexColor(normalizedSecondaryColor)) {
    postValues.secondary_accent_color = normalizedSecondaryColor
  }

  return postValues as IntegrationPost
}
